export enum PolicyTab {
  Privacy = 'privacy',
  Terms = 'terms',
  ChildSafety = 'child-safety',
}
